import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import Fabrics from './Fabrics.js'
import FiltersView from './FiltersView.js'
import {
  getBrands,
  getColorMap,
  getFabrics,
  getMaterials,
  getPatterns,
  getUses,
} from '../../actions/fabricsActions.js'
import SingleFabric from './SingleFabric.js'
import { withRoutingTracker } from '../../HOC/withRoutingTracker.js'
import { isNumeric } from '../../utils/utils.js'

class FabricsPage extends PureComponent {
  constructor(props) {
    super(props)
    const { history } = props
    const pathView = history?.location?.search?.split('=')?.pop()
    const view = isNumeric(pathView) ? 'single-fabric' : pathView

    this.state = {
      currentView: view || 'fabrics',
    }
  }

  componentDidMount() {
    const { dispatch } = this.props

    const apiParams = [
      {
        name: 'per_page',
        value: '100',
      },
      {
        name: 'page',
        value: '1',
      },
      {
        name: 'orderby',
        value: 'menu_order',
      },
      {
        name: 'order',
        value: 'asc',
      },
    ]

    dispatch(getFabrics(apiParams))
    dispatch(getColorMap())
    dispatch(getMaterials())
    dispatch(getUses())
    dispatch(getBrands())
    dispatch(getPatterns())
  }

  _switchCurrentView = (view) => () => {
    this.setState({ currentView: view })
  }

  _getCurrentView = () => {
    const { currentView } = this.state

    switch (currentView) {
      case 'fabrics':
        return <Fabrics switchCurrentView={this._switchCurrentView} />
      case 'single-fabric':
        return <SingleFabric switchCurrentView={this._switchCurrentView('fabrics')}/>
      case 'filters':
        return <FiltersView switchCurrentView={this._switchCurrentView('fabrics')}/>
    }
  }

  render() {
    return this._getCurrentView()
  }
}

const mapStateToProps = (state) => ({
  general: state.general,
  fabrics: state.fabrics,
})

export default connect(mapStateToProps)(withRoutingTracker(FabricsPage))
